import { useQuery } from "@apollo/client";
import { Button, Card, ControlGroup, InputGroup } from "@blueprintjs/core";
import _ from "lodash";
import { useState } from "react";
import { LCSCTypes } from "../../../api/extra_schema";
import { FlexContainer } from "../../../components/flex/Flex";
import { _t } from "../../../utils/pack";
import { LCSC_query } from "./graphql";

const Result = ({ product }: { product: LCSCTypes.Product }) => {
  // const image = _.find(_.find(product.productImages, { type: "front" })?.data, {
  //   size: "96x96",
  // });

  return (
    <div
      style={{
        padding: "1em",
        border: "1px solid gray",
        borderRadius: 3,
        display: "flex",
        flexDirection: "row",
        minHeight: 100,
        gap: "1em",
        textDecoration: "none",
        color: "white",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 5,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          Code: {product.code}
          <Button
            minimal
            onClick={() => navigator.clipboard.writeText(product.code)}
            icon={"duplicate"}
            style={{ marginLeft: 5 }}
          />
        </div>
        <div>
          MPN:{" "}
          <a href={product.url} target="_blank" rel="noreferrer">
            {product.id}
          </a>
        </div>
        {/* <div>MNF: {product.manufacturer}</div>
        <div>Package: {product.package}</div>
        <div>Stock: {product.stock}</div> */}
      </div>
      {/* {image ? (
        <div>
          <img src={image.url} />
        </div>
      ) : null} */}
      <div>
        {_(product.productPriceList)
          .orderBy(["ladder"])
          .map((price, index) => (
            <div key={product.id + "_price_" + index}>
              {price.ladder}: {price.usdPrice}
            </div>
          ))
          .value()}
      </div>
    </div>
  );
};

const ResultView = ({ result }: { result: LCSCTypes.SearchResult | null }) => {
  if (result === null)
    return <div style={{ marginTop: "1em" }}>No results</div>;

  return (
    <div
      style={{ display: "flex", gap: 10, marginTop: "1em", flexWrap: "wrap" }}
    >
      {_.map(result.data, (p) => (
        <Result key={"r_" + p.id} product={p} />
      ))}
    </div>
  );
};

export const LCSCLookup = (props: any) => {
  const lcsc_query = useQuery<
    { lcsc_query: { global_search: LCSCTypes.SearchResult } },
    { query: string }
  >(LCSC_query, {
    skip: true,
    fetchPolicy: "network-only",
    nextFetchPolicy: "network-only",
  });

  const [result, setResult] = useState<null | LCSCTypes.SearchResult>(null);
  const [query, setQuery] = useState("");
  const [submitting, setSubmitting] = useState(false);

  console.log({ result, query, submitting });

  const fetch = () => {
    _t(setSubmitting(true))
      .then(() => lcsc_query.refetch({ query: query }))
      .then((data) => {
        if (data.data.lcsc_query?.global_search.data.length > 0)
          return setResult(data.data.lcsc_query.global_search);
        setResult(null);
      })
      .catch(() => setResult(null))
      .finally(() => setSubmitting(false));
  };

  return (
    <FlexContainer>
      <Card style={{ margin: "2em", marginTop: 0 }}>
        <ControlGroup>
          <InputGroup
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyPress={(e) => {
              console.log(e.key);
              if (!submitting && e.key === "Enter") fetch();
            }}
            disabled={submitting}
          />
          <Button
            icon="chevron-right"
            intent="primary"
            onClick={() => fetch()}
            disabled={submitting}
          />
        </ControlGroup>
        <ResultView result={result} />
      </Card>
    </FlexContainer>
  );
};
